// ============================================================
// EYAL DELIVERY AREAS
// ============================================================

export const ALLOWED_AREAS = [
  "Alathur / Alathur Gate",
  "Anangur / Anangur Pirivu",
  "Anangur Village & Pudur",
  "Athanur Amman Kovil",
  "Avarangadu",
  "C.N. Palayam (Chinnappampalayam)",
  "Cauvery R.S. (Railway Station Road)",
  "Chinnagoundanur",
  "Devanankurichi",
  "Elandakuttai",
  "Emapalli / Vittampalayam Pirivu",
  "Kailasampalayam",
  "Kallangattuvalasu",
  "Kallikkadu",
  "Kaveripatti Pirivu",
  "Kokkarayanpettai (Cauvery riverside belt)",
  "Komarapalayam Town (Salem Main Road, Bus Stand, New Pallipalayam Road, NH-544 Bypass Bridge, Cauvery River Bridge border)",
  "Kootapalli / Kootapalli Colony",
  "Kumaramangalam / Kumaramangalam Tollgate",
  "Kuppandapalayam / Chinna Kuppandapalayam",
  "Modamangalam",
  "Morur / Morur Pirivu",
  "Paalmadai",
  "Pachampalayam",
  "Padaiveedu / Sundaram Colony",
  "Padaiveedu Town Panchayat",
  "Pallipalayam Agraharam",
  "Pallipalayam Town (Bus Stand, Railway Gate, Odapalli, Cauvery Bridge Junction)",
  "Pappampalayam",
  "Pirivu Road",
  "Sankagiri R.S. (Railway Colony, Pullipalayam, Cement Factory Area)",
  "Sankagiri Town (Old Bus Stand, New Bye-pass, Sankagiri Durg Fort foothills, Court & Taluk Office junction)",
  "Sankari West (ICL Colony & Quarry Area)",
  "SPB Colony / Seshasayee Paper Board area",
  "Thokavadi (KSR Institutions Hub / Lion City)",
  "Tiruchengode Town (Arthanareeswarar Foothill, Gandhi Statue, Sankagiri Road, Velur Road, Old & New Bus Stands)",
  "Valayakaranur",
  "Varagurampatti",
  "Vellakkalpatti / Sanyasikaradu",
  "Veppadai (Bus Stop, Bazaar, Powerloom Industrial Belt)",
  "Veppadai Bypass",
  "Vittampalayam",
];